<!-- os botões da coluna de statuses são exibidos de acordo o status da rodada de investimento -->
<div class="actions-buttons">             
    <button class="btn table-btn" title="ON" 
        *ngIf="objeto.status === 'STAND_BY' || (objeto.status === 'SUCESSO' && exibirBotaoOnAposSucessoRodada(objeto.dataTermino))" 
        (click)="executarTrocaDeStatus(statusRodada.ON, objeto)">
        <icons-primecap name="rocket"></icons-primecap>
    </button>

    <button class="btn table-btn" title="Stand by" 
        *ngIf="objeto.status === 'ON' || objeto.status === 'VENCEU' || objeto.status === 'SUCESSO' || objeto.status === 'CANCELADA'" 
        (click)="executarTrocaDeStatus(statusRodada.STAND_BY, objeto)">
        <icons-primecap name="clockwise"></icons-primecap>
    </button>

    <button class="btn table-btn" title="Cancelar" 
        *ngIf="objeto.status === 'STAND_BY'" 
        (click)="executarTrocaDeStatus(statusRodada.CANCELADA, objeto)">
        <icons-primecap name="close"></icons-primecap>
    </button>
</div>